/**
 * Global vuex state.
 */

// default export.
export default {
  loading: false,

  /**
   * JWT Token and Data.
   */
  jwt: {
    token: null,
    data: null
  },

  tenants: [],

  patient: {
    id: null,
    name: null,
    email: null
  },

  professional: {
    id: null,
    name: null,
    email: null
  },

  /**
   * Basic user information.
   */
  user: {
    id: null,     // user id.
    name: null,   // user name.
    email: null  // user email.
  },

  settings: {
    notify: {
      schedule: true,
      cancel: true,
      transfer: false,
      send: {
        email: true,
        sms: false,
        push: {
          web: true,
          app: false
        }
      },
      dependents: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js